import { createSdk } from '@knots/api-sdk'
import { createSdk as createFlowSdk } from '@knots/flow-sdk'
import type { Middleware } from 'openapi-fetch'

import { API_URL, CF_API_URL, FLOW_API_URL } from '@/config'
import storage from '@/utils/storage'

const auth: Middleware = {
  async onRequest({ request }) {
    const token = storage.getToken()

    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`)
    }

    return request
  },
}

const authFailHandler: Middleware = {
  onResponse({ response }) {
    const urlObj = new URL(response.url)

    try {
      if (urlObj.pathname !== '/oauth2/token' && (response.status === 403 || response.status === 401)) {
        storage.clearToken()
        window.location.assign(window.location.origin as unknown as string)
      }

      return response
    } catch (error: any) {
      if (urlObj.pathname !== '/oauth2/token' && (error.status === 403 || error.status === 401)) {
        storage.clearToken()
        window.location.assign(window.location.origin as unknown as string)
        throw new Error('Bad authentication token')
      } else {
        throw error
      }
    }
  },
}

const serverErrorHandler: Middleware = {
  async onResponse({ response }) {
    const data = await response.clone().json()

    if (response.status >= 400 || data?.error) {
      const apiError = new Error(response.statusText)
      // @ts-expect-error maybe we'll do a generic apiError class later
      apiError.data = data

      throw apiError
    }

    return response
  },
}

export const flowApiSdk = createFlowSdk({
  baseUrl: FLOW_API_URL,
})

flowApiSdk.use(auth)
flowApiSdk.use(serverErrorHandler)
flowApiSdk.use(authFailHandler)

export const knotsApiSdk = createSdk({
  baseUrl: API_URL,
})

knotsApiSdk.use(auth)
knotsApiSdk.use(serverErrorHandler)
knotsApiSdk.use(authFailHandler)

export const knotsCFApiSdk = createSdk({
  baseUrl: CF_API_URL,
})

knotsCFApiSdk.use(auth)
knotsCFApiSdk.use(serverErrorHandler)
knotsCFApiSdk.use(authFailHandler)
